export { appLocaleSettings, localeOptions } from '@outpoll/i18n';
